import React from 'react'
import { Redirect } from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import { deepOrange500, lightGreenA700 } from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import ProjectForm from './ProjectForm'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')

class EditProject extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      project: this.props.project,
      changed: false,
      saved: false,
      error: '',
      snackbarMessage: ''
    }
  }

  _save = attributes => {
    // Adjust attributes
    delete attributes.clientName
    delete attributes.agencyName
    delete attributes.agencyProducerName
    delete attributes.directorOneName
    delete attributes.directorTwoName

    // Massage data
    attributes.producerId = attributes.userId // For now
    attributes.targetMargin = Number(attributes.targetMargin) / 100
    attributes.date = attributes.date || new Date()

    // Update!
    ProjectStore.update(this.state.project.id, attributes)
      .then(result => {
        this.setState({
          saved: true,
          changed: false,
          error: '',
          result: result,
          snackbarMessage: `Project "${attributes.name}" saved!`
        })
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _changed = didChange => this.setState({ changed: didChange, saved: false })

  _closeErrorDialog = () => this.setState({ error: '' })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const { quoteId, addNewQuote, cloneQuote } = this.props

    const {
      redirect,
      project,
      changed,
      saved,
      snackbarMessage,
      error
    } = this.state

    if (redirect) return <Redirect push to={redirect} />

    return (
      <section>
        <ProjectForm
          formTitle={
            <span>
              {project.attributes.name}&nbsp;
              {changed && <ActionCompareArrows color={deepOrange500} />}
              {saved && <ActionCheckCircle color={lightGreenA700} />}
            </span>
          }
          action="edit"
          project={project}
          quoteId={quoteId}
          addNewQuote={addNewQuote}
          cloneQuote={cloneQuote}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={() => this._redirectTo('/projects')}
        />

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes"
        >
          <p>
            The project <strong>{project.attributes.name}</strong> remains
            unchanged.
          </p>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }
}

export default EditProject



// WEBPACK FOOTER //
// ./src/components/Projects/EditProject.jsx